<template>
	<div class="ts-overflow-hidden">
		<ts-card>
			<ts-card-wrapper>
				<div class="row">
					<div class="col-md-12 form-group ts-px-2 ts-pt-6 ts-space-x-2">
						<div class="ts-flex ts-justify-between">
							<div class="ts-justify-start">
								<ts-button v-if="isStaff || isTeacher" class="ts-mb-1" color="primary" outline
									@click.prevent="() => (show_form = true)">{{ $t('add_new') }}
								</ts-button>
								<ts-button v-if="isStaff" class="ts-ml-2" outline color="info"
									@click.prevent="onReleasePortfolio" :disabled="!selectedItems.length > 0">
									{{ $t('portfolioPhoto.release') }}
								</ts-button>
							</div>
							<div class="ts-flex">
								<!-- <label class="form-col-label control-label ts-mb-2"></label> -->
								<ts-input v-model="search" style="width: 300px;"
									:placeholder="$t('portfolioPhoto.search')" />
								<ts-button outline class="ml-2" v-tooltip="$t('filter')" @click.prevent="visible = true">
									<i class="fa fa-filter"></i>
								</ts-button>
							</div>
						</div>
					</div>
				</div>
			</ts-card-wrapper>
			<div class="overflow-auto">
				<ts-table :columns="columns" :records="resources" :loading="loading" :showCheckbox="true"
					@check-items="checkItem">
					<template v-slot="{ record }">
						<td>
							{{ record.portfolio_name_en }}
						</td>
						<td class="ts-text-center">
							{{ record.setup_date }}
						</td>
						<td class="ts-text-center">
							{{ record.ac_year }}
						</td>
						<td>
							{{ record.term_name }}
						</td>
						<td>
							{{ record.academic_class ? record.academic_class.class_name : '' }}
						</td>
						<td>
							{{ record.student ? record.student.first_name_en + ' ' + record.student.last_name_en : '' }}
						</td>
						<td>
							{{ record.photo_upload_by_name }}
						</td>
						<td class="text-right ts-whitespace-no-wrap ts-px-8">
							<a-popconfirm placement="leftTop" :title="$t('are_you_sure_to_send')" :ok-text="$t('yes')"
								:cancel-text="$t('no')" @confirm="sendNotification(record)">
								<a href="#" v-if="record.is_publish != 1 && isStaff" v-tooltip="$t('send')"
									class="mr-2 text-primary">
									<i class="far fa-paper-plane"></i>
								</a>
							</a-popconfirm>
							<a href="#" class="mr-2 text-primary" @click.prevent="onEdit(record)" v-tooltip="$t('edit')">
								<i class="fas fa-edit"></i>
							</a>
							<a href="#" class="text-danger" @click.prevent="deleteRecord(record.upload_id)"
								:disabled="record._deleting" v-tooltip="$t('delete')">
								<i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
								<i class="fas fa-trash" v-else></i>
							</a>
						</td>
					</template>
				</ts-table>
			</div>
			<div class="d-flex justify-content-end p-15">
				<ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
			</div>
		</ts-card>
		<a-modal v-if="show_form" v-model="show_form" :title="$t('portfolioPhoto.pageTitle')" :zIndex="1020" :footer="null"
			:maskClosable="false" width="45%" @cancel="clearEdit">
			<form-component ref="form_component" @close="() => (show_form = false)" @fetchData="fetchData"
				@cancel="clearEdit" />
		</a-modal>
		<a-drawer :title="$t('filter')" placement="right" :closable="false" :visible="visible"
			@close="() => (visible = false)" :zIndex="1020" width="400px">
			<ts-loading-banner :loading="loadingFilter">
				<div class="ts-space-y-3">
					<div class="row">
						<div class="col-md-12 ts-mb-2">
							<label>{{ $t('portfolioPhoto.dateRange') }}</label>
							<a-range-picker format="DD-MM-YYYY" :defaultValue="rangeDate" :defaultPickerValue="rangeDate"
								@change="dateRangeChange">
								<template slot="renderExtraFooter"></template>
							</a-range-picker>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							<label>{{ $t('portfolioPhoto.acYear') }}</label>
							<div class="form-group ts-w-full">
								<a-select style="width: 100%" v-model="ac_year_id" :options="years" showSearch
									mode="multiple" :filterOption="(input, option) =>
										option.componentOptions.children[0].text
											.toLowerCase()
											.indexOf(input.toLowerCase()) >= 0
										" :maxTagCount="1" :maxTagTextLength="17" :placeholder="$t('all')">
								</a-select>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							<label>{{ $t('portfolioPhoto.portfolioType') }}</label>
							<a-select v-model="portfolio_type_id" mode="multiple" style="width: 100%"
								:placeholder="$t('all')" :max-tag-count="1" :max-tag-text-length="10" :options="portfolios"
								:filterOption="(input, option) =>
									option.componentOptions.children[0].text
										.toLowerCase()
										.indexOf(input.toLowerCase()) >= 0"></a-select>
						</div>
					</div>
				</div>
			</ts-loading-banner>
		</a-drawer>
	</div>
</template>

<script>

import { Errors } from 'form-backend-validation'
import FormComponent from './form'
import { debounce } from 'lodash'
import * as FileDownload from 'downloadjs'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
	name: 'portfolioPhoto',
	components: {
		FormComponent
	},
	data() {
		return {
			errors: new Errors(),
			loading: false,
			show_form: false,
			visible: false,
			loadingFilter: false,
			portfolio_loading: false,
			model: {},
			rangeDate: [moment().add(-1, 'months'), moment()],
			years: [],
			portfolios: [],
			selectedItems: [],
			upload_id: null
		}
	},
	computed: {
		...mapState('portfolioPhoto', ['resources', 'pagination']),
		columns() {
			return [
				{
					name: this.$t('portfolioPhoto.portfolioName'),
				},
				{
					name: this.$t('portfolioPhoto.setupDate'),
					style: 'text-align: center;'
				},
				{
					name: this.$t('portfolioPhoto.acYear'),
					style: 'text-align: center;'
				},
				{
					name: this.$t('portfolioPhoto.academicTerm'),
				},
				{
					name: this.$t('portfolioPhoto.className'),
				},
				{
					name: this.$t('portfolioPhoto.studentName'),
				},
				{
					name: this.$t('portfolioPhoto.createdBy'),
				},
				{
					name: this.$t('portfolioPhoto.action'),
					style: 'text-align: right;'
				},
			]
		},
		isStaff() {
			return this.$store.getters.isStaffLogin
		},
		isTeacher() {
			return this.$store.getters.isTeacherLogin
		},
		search: {
			get() {
				return this.$store.state.portfolioPhoto.search
			},
			set(val) {
				this.$store.commit('portfolioPhoto/SET_SEARCH', val)
			}
		},
		ac_year_id: {
			get() {
				return this.$store.state.portfolioPhoto.ac_year_id
			},
			set(newValue) {
				this.$store.commit('portfolioPhoto/SET_YEAR_ID', newValue)
			}
		},
		portfolio_type_id: {
			get() {
				return this.$store.state.portfolioPhoto.portfolio_type_id
			},
			set(newValue) {
				this.$store.commit('portfolioPhoto/SET_PORTFOLIO_ID', newValue)
			}
		}
	},
	created() {
		this.fetchResource();
	},
	methods: {
		async fetchResource() {
			await this.$store
				.dispatch('portfolioPhoto/getYear')
				.then(response => {
					this.years = response.data.map(el => ({
						value: el.ac_year_id,
						label: el.ac_year
					}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
			await this.$store
				.dispatch('portfolioPhoto/getPortfolio')
				.then(response => {
					this.portfolios = response.data.map(el => ({
						value: el.portfolio_type_id,
						label: el.portfolio_name_en
					}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
		},
		fetchData(attributes) {
			this.loading = true
			this.$store
				.dispatch('portfolioPhoto/fetch', attributes)
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		dateRangeChange(dateRange) {
			this.$store.commit(
				'portfolioPhoto/SET_DATE_FROM',
				dateRange[0].format('DD-MM-YYYY')
			)
			this.$store.commit(
				'portfolioPhoto/SET_DATE_TO',
				dateRange[1].format('DD-MM-YYYY')
			)
			this.fetchData()
		},
		clearEdit() {
			this.$store.commit('portfolioPhoto/SET_EDIT_DATA', {})
			this.show_form = false
			this.fetchData()
		},
		onEdit(items) {
			this.$store.commit('portfolioPhoto/SET_EDIT_DATA', items)
			this.show_form = true
		},
		deleteRecord(upload_id) {
			this.loading = true
			this.$store
				.dispatch('portfolioPhoto/destroy', upload_id)
				.then(response => {
					this.loading = false
					this.fetchData()
					this.$toasted.success(response.message)
				})
				.catch(error => {
					this.loading = false
					this.$toasted.error(error.message)
				})
		},
		sendNotification(record) {
			this.selectedItems = []
			this.selectedItems.push(record.upload_id)
			this.onReleasePortfolio()
			this.selectedItems = []
		},
		checkItem(portfolioItems) {
			this.selectedItems = portfolioItems.map($item => $item.upload_id)
		},
		onReleasePortfolio() {
			this.portfolio_loading = true
			this.$store
				.dispatch('portfolioPhoto/releasePortfolio', this.selectedItems)
				.then(response => {
					this.$toasted.success(response.message)
					this.fetchData()
				})
				.catch(error => {
					this.$toasted.success(error.message)
				})
				.finally(() => {
					this.portfolio_loading = false
				})
		},
		download() {
			FileDownload(this.model.file_path)
		}
	},
	beforeRouteLeave(to, from, next) {
		this.$store.commit('portfolioPhoto/RESET_STATE')
		next()
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			vm.fetchData()
		})
	},
	watch: {
		search: debounce(function () {
			this.fetchData()
		}, 500),
		ac_year_id: debounce(function (value) {
			this.fetchData({ ac_year_id: value })
		}, 500),
		portfolio_type_id: debounce(function (value) {
			this.fetchData({ portfolio_type_id: value })
		}, 500)
	}
}
</script>
<style scoped lang="scss"></style>
